export default {"src":"https://filecdn-other.xingyeai.com/xingye-ugc/_next/static/media/info.ee13b24a.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};